var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let gpuAdapter = null;
let gpuDevice = null;
export function getGPUDevice() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!navigator.gpu) {
            console.error('WebGPU is not supported in this browser');
            return null;
        }
        if (!gpuAdapter) {
            //reason: only here we get the gpuAdapter
            // eslint-disable-next-line no-restricted-syntax
            gpuAdapter = yield navigator.gpu.requestAdapter({ powerPreference: 'high-performance' });
            if (gpuAdapter == null)
                return null;
        }
        let isLost = false;
        if (gpuDevice) {
            gpuDevice.lost.then(() => {
                isLost = true;
            });
            yield new Promise((r) => setTimeout(r, 10)); // wait to see if the device is lost
        }
        if (!gpuDevice || isLost) {
            const requiredBufferSize = 1000000000; // ~1000MB
            const adapterLimits = gpuAdapter.limits;
            const buffferSizeLimit = adapterLimits.maxBufferSize;
            const storageBufferSizeLimit = adapterLimits.maxStorageBufferBindingSize;
            try {
                gpuDevice = yield gpuAdapter.requestDevice({ requiredLimits: {
                        maxBufferSize: Math.min(buffferSizeLimit, requiredBufferSize),
                        maxStorageBufferBindingSize: Math.min(storageBufferSizeLimit, requiredBufferSize)
                    } });
                return gpuDevice;
            }
            catch (e) {
                console.error('Failed to create device with required limits', e);
                gpuDevice = yield gpuAdapter.requestDevice();
                return gpuDevice;
            }
        }
        return gpuDevice;
    });
}
export function getGPUAdapterDescription() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!navigator.gpu) {
            console.error('WebGPU is not supported in this browser');
            return null;
        }
        if (!gpuAdapter) {
            // reason: only here we get the gpuAdapter
            // eslint-disable-next-line no-restricted-syntax
            gpuAdapter = yield navigator.gpu.requestAdapter();
            if (gpuAdapter == null)
                return null;
        }
        let info = null;
        if ('info' in gpuAdapter)
            info = gpuAdapter.info;
        // this option is sort of deprecated but still available in every initial release
        // else if ('requestAdapterInfo' in gpuAdapter && typeof gpuAdapter.requestAdapterInfo === 'function')
        //   info = (await gpuAdapter.requestAdapterInfo()) as GPUAdapterInfo;
        if (!info)
            return 'No GPU description available';
        const outString = replaceEmptyString(info.description, replaceEmptyString(info.vendor, 'No GPU description available'));
        return outString;
    });
}
function replaceEmptyString(str, replacement) {
    return !str || str == '' ? replacement : str;
}
//# sourceMappingURL=getGPUDevice.js.map